import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getSixthAnalyses,
  getSixthAnalysis,
  createSixthAnalysis,
  clearLocalSixthAnalyses,
  clearLocalActiveSixthAnalysis
} from './actions';

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  sixthAnalysis: { id: '', inputs: null, result: null, status: '', updated_at: '' },
  loading: { all: false, sixthAnalysis: false }
};

const slice = createSlice({
  name: 'sixthAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSixthAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSixthAnalyses.fulfilled, (state, action) => {
        const { sixth_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...sixth_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getSixthAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSixthAnalysis.pending, (state) => {
        state.loading.sixthAnalysis = true;
      })
      .addCase(getSixthAnalysis.fulfilled, (state, action) => {
        const { data: { sixth_analysis }, cable } = action.payload;
        const foundedSixthAnalysis = !!_find(state.all.data, (s) => s.id === sixth_analysis.id);
        const updatedSixthAnalysis = { ...state.sixthAnalysis, ...sixth_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSixthAnalysis ? _map(state.all.data, (e) => e.id === sixth_analysis.id ? { ...e, ...sixth_analysis } : e) : [...[sixth_analysis], ...oldAllData]; 
        const pagination = foundedSixthAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.sixthAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSixthAnalysis && !cable) state.sixthAnalysis = updatedSixthAnalysis;       
      })
      .addCase(getSixthAnalysis.rejected, (state) => {
        state.loading.sixthAnalysis = false;
      })
      .addCase(createSixthAnalysis.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(createSixthAnalysis.fulfilled, (state, action) => {
        const { sixth_analysis } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[sixth_analysis], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.all = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.sixthAnalysis = sixth_analysis;  
      })
      .addCase(createSixthAnalysis.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(clearLocalSixthAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSixthAnalysis, state => {
        state.sixthAnalysis = initialState.sixthAnalysis;
      })
  }
})

export default slice.reducer;